import SidebarMenu from "react-bootstrap-sidebar-menu";
import { Link } from "react-router-dom";
import React from "react";
import { store } from "../reducer/Store";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import { Spinner, Form, Badge } from "react-bootstrap";
import ApiService from "../services/ApiService";
//import { ReactComponent as PictoChallenge } from "../assets/svg/challenge.svg";
import { ReactComponent as PictoPlanTrade } from "../assets/svg/plan-trade.svg";
import { ReactComponent as PictoPdf } from "../assets/svg/pdf.svg";
import { ReactComponent as PictoSuiviClient } from "../assets/svg/suivi-client.svg";
import { ReactComponent as PictoXls } from "../assets/svg/xls.svg";

const Sidebar = () => {
  const { state, dispatch } = React.useContext(store);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [noResultMessage, setNoResultMessage] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [suggestions, setSuggestions] = React.useState([]);
  const [expand, setExpand] = React.useState(
    window.screen.width <= 768 ? false : true
  );

  const handleChange = (e) => {
    setSearchQuery(e.target.value);
    if (e.target.value.length >= 2) {
      setLoader(true);
      setNoResultMessage(false);
      ApiService.request(
        { search: e.target.value.toLowerCase() },
        "customers-search",
        "post"
      )
        .then(function (response) {
          setLoader(false);
          if (response.message === "No result.") {
            setNoResultMessage(true);
          } else {
            const custosmers = response.data;
            setSuggestions(custosmers);
          }
        })
        .catch(function (error) {
          // manque un message quand c'est une error
          console.log(error);
          setSuggestions([]);
          setLoader(false);
        });
    } else if (e.target.value.length === 0) {
      setSuggestions([]);
      setNoResultMessage(false);
      //dispatch({ type: "SET_DATASELECTEDCLIENT", payload: [] });
    }
  };

  /**
   * Cette fonction est appelée lorsqu'un utilisateur clique sur une suggestion de client.
   * Elle met à jour la valeur de la requête de recherche avec le nom du client sélectionné, enregistre le client sélectionné dans le state via la méthode dispatch, le stocke également dans le local storage et efface la liste des suggestions.
   * @param {Object} suggestion - La suggestion de client sur laquelle l'utilisateur a cliqué.
   */
  const handleSuggestionClick = (suggestion) => {
    setSearchQuery(suggestion.name);
    dispatch({ type: "SET_DATASELECTEDCLIENT", payload: suggestion });
    localStorage.setItem("dataSelectedCustomer", JSON.stringify(suggestion));
    setSuggestions([]);
  };

  /**
   * Cette fonction récupère les informations d'un client à partir de son identifiant. Elle effectue une requête GET vers l'API pour obtenir les données du client correspondant à l'identifiant spécifié. Une fois les données récupérées avec succès, elle met à jour le state avec les informations du client via la méthode dispatch.
   * En cas d'erreur lors de la requête ou si l'utilisateur n'est pas authentifié, elle gère ces cas en affichant des messages appropriés et en effectuant les actions nécessaires.
   * @param {Number} id - L'identifiant du client à récupérer.
   */
  const getCustomer = async (id) => {
    setLoader(true);
    ApiService.request({}, "customers/" + id, "get")
      .then(function (response) {
        // console.log(response.data);
        setLoader(false);
        dispatch({ type: "SET_DATACUSTOMER", payload: response.data });
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   *Cette fonction récupère le nombre total d'opérations pour un client donné.
   * Elle effectue une requête GET vers l'API en utilisant les marques actuelles, l'identifiant du client sélectionné et l'année actuelle.
   * Le résultat retourné est le nombre total d'opérations pour le client spécifié. Une fois le résultat obtenu avec succès, la fonction met à jour le state en utilisant la méthode dispatch avec le nombre total d'opérations.
   *En cas d'erreur lors de la requête ou si l'utilisateur n'est pas authentifié, elle gère ces cas en affichant des messages appropriés et en effectuant les actions nécessaires.
   */
  const getTotalNumberOfOperationByCustomer = async () => {
    var brands = [];
    JSON.parse(localStorage.getItem("currentBrands")).map((brand) =>
      brands.push(brand.value)
    );
    ApiService.request(
      {},
      `numbers-of-operations-by-brands-customer-year/${brands}/${state.dataSelectedClient.id
      }/${JSON.parse(localStorage.getItem("currentYear")).value}`,
      "get"
    )
      .then(function (response) {
        //console.log(response.data);
        dispatch({
          type: "SET_TOTALNUMBEROFCUSTOMEROPERATIONS",
          payload: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction récupère le nombre total de défis pour un client donné.
   * Elle effectue une requête GET vers l'API en utilisant les marques actuelles, l'identifiant du client sélectionné et l'année actuelle. Le résultat retourné est le nombre total de défis pour le client spécifié.
   * Une fois le résultat obtenu avec succès, la fonction met à jour le state en utilisant la méthode dispatch avec le nombre total de défis. En cas d'erreur lors de la requête ou si l'utilisateur n'est pas authentifié, elle gère ces cas en affichant des messages appropriés et en effectuant les actions nécessaires.
   */
  const getTotalNumberOfChallengesByCustomer = async () => {
    var brands = [];
    JSON.parse(localStorage.getItem("currentBrands")).map((brand) =>
      brands.push(brand.value)
    );
    ApiService.request(
      {},
      `numbers-of-challenges-by-brands-customer-year/${brands}/${state.dataSelectedClient.id
      }/${JSON.parse(localStorage.getItem("currentYear")).value}`,
      "get"
    )
      .then(function (response) {
        //console.log(response.data);
        dispatch({
          type: "SET_TOTALNUMBEROFCUSTOMERCHALLENGES",
          payload: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction gère le basculement de l'état d'expansion de la sidebar.
   * Lorsque la sidebar est déployée, la valeur de 'expanded' est true.
   * Dans ce cas, la fonction met à jour l'état d'expansion en utilisant la méthode setExpand avec la valeur true. Lorsque la sidebar est réduite, la valeur de 'expanded' est false.
   * Dans ce cas, la fonction met à jour l'état d'expansion en utilisant la méthode setExpand avec la valeur false.
   */
  const handleToggle = (expanded) => {
    // La sidebar vient d'être déployée
    if (expanded) {
      setExpand(true);
    }
    // La sidebar vient d'être réduite
    else {
      setExpand(false);
    }
  };

  React.useEffect(() => {
    if (state.dataSelectedClient && state.dataSelectedClient.id) {
      getCustomer(state.dataSelectedClient.id);
    }
  }, [state.dataSelectedClient]);

  React.useEffect(() => {
    if (
      state.dataSelectedClient &&
      state.dataSelectedClient.id &&
      state.currentBrands &&
      state.currentBrands.length > 0
    ) {
      getTotalNumberOfOperationByCustomer();
      getTotalNumberOfChallengesByCustomer();
    } else {
      dispatch({
        type: "SET_TOTALNUMBEROFCUSTOMEROPERATIONS",
        payload: 0,
      });
      dispatch({
        type: "SET_TOTALNUMBEROFCUSTOMERCHALLENGES",
        payload: 0,
      });
    }
  }, [state.dataSelectedClient, state.currentBrands, state.currentYear]);
  return (
    <SidebarMenu
      bg="white"
      expand="sm"
      expanded={expand}
      onToggle={handleToggle}
      className="sidebar-trade"
    >
      <SidebarMenu.Collapse>
        <SidebarMenu.Header>
          <Link to="/client">
            {window.screen.width > 768 && (
              <SidebarMenu.Brand>
                <img
                  src="/assets/img/logo/logo.svg"
                  alt="Pierre Fabre"
                  width="200"
                  height="35"
                />
              </SidebarMenu.Brand>
            )}
          </Link>
          <SidebarMenu.Toggle />
        </SidebarMenu.Header>
        <SidebarMenu.Body>
          <SidebarMenu.Nav>
            <SidebarMenu.Nav>
              {!expand ? (
                <SidebarMenu.Nav.Link onClick={() => handleToggle(!expand)}>
                  <SearchOutlinedIcon />
                </SidebarMenu.Nav.Link>
              ) : (
                <div className="w-100">
                  <Form.Control
                    type="text"
                    className="search"
                    placeholder={expand ? "Rechercher ..." : "TATA"}
                    autoFocus
                    required
                    value={searchQuery}
                    onChange={(e) => handleChange(e)}
                  />
                  {!loader ? (
                    <>
                      {!noResultMessage ? (
                        suggestions.length > 0 && (
                          <ul className="list-group search-bar">
                            {suggestions.map((suggestion, i) => (
                              <li
                                key={i}
                                className="list-group-item"
                                onClick={() =>
                                  handleSuggestionClick(suggestion)
                                }
                              >
                                {`${suggestion.id} - ${suggestion.name}`}
                              </li>
                            ))}
                          </ul>
                        )
                      ) : (
                        <ul className="list-group">
                          <li className="list-group-item">Aucun resultat</li>
                        </ul>
                      )}
                      {state.dataSelectedClient &&
                        state.dataSelectedClient.id ? (
                        state.dataCustomer ? (
                          <>
                            <div className=" pharma_name blue text-uppercase fw700 p-3 pb-0 ">
                              {state.dataCustomer.name} -{" "}
                              {state.dataCustomer.id}
                            </div>
                            <div className="pharma_meta p-3 py-1 ">
                              <div className="pharma_cip">
                                {state.dataCustomer.cip_pharma
                                  ? "CIP : " + state.dataCustomer.cip_pharma
                                  : "CIP : "}
                              </div>

                              <div className="pharma_groupement">
                                {state.dataCustomer.group
                                  ? "Gpt : " + state.dataCustomer.group.name
                                  : "Gpt : "}
                              </div>

                              <div className="pharma_groupement">
                                {state.dataCustomer.status
                                  ? "Statut : " + state.dataCustomer.status
                                  : "Statut : "}
                              </div>
                            </div>
                            <hr />
                          </>
                        ) : (
                          ""
                        )
                      ) : (
                        <div className="text-center p-4 red">
                          Sélectionnez un client
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="text-center pt-5">
                      <Spinner
                        animation={loader ? "border" : false}
                        role="status"
                      ></Spinner>
                    </div>
                  )}
                </div>
              )}
            </SidebarMenu.Nav>

            <SidebarMenu.Nav.Link as={Link} to="/client" eventKey="menu_client">
              <SidebarMenu.Nav.Icon>
                <PersonOutlineOutlinedIcon />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title>Client</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
            <SidebarMenu.Nav.Link
              as={Link}
              to="/operations"
              eventKey="menu_operation"
            >
              <SidebarMenu.Nav.Icon>
                <LocalOfferOutlinedIcon />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title>
                Opérations{" "}
                <Badge
                  pill
                  bg="light"
                  className="sidebar-operation-challenge-menu-total-number"
                >
                  {state.totalNumberOfCustomerOperations}
                </Badge>
              </SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
            {/*
            <SidebarMenu.Nav.Link
              as={Link}
              to="/challenges"
              eventKey="menu_challenges"
            >
              <SidebarMenu.Nav.Icon>
                <PictoChallenge
                  className="sidebarIcon"
                  alt="Challenge"
                  style={{ width: 24, height: 24 }}
                />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title>
                Challenges{" "}
                <Badge
                  pill
                  bg="light"
                  className="sidebar-operation-challenge-menu-total-number"
                >
                  {state.totalNumberOfCustomerChallenges}
                </Badge>
              </SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
            */}
            <hr />
            <SidebarMenu.Nav.Link
              as={Link}
              to="/rapports-pdf"
              eventKey="menu_rapports"
            >
              <SidebarMenu.Nav.Icon>
                <PictureAsPdfOutlinedIcon />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title>Rapport</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>

            <SidebarMenu.Nav.Link
              as={Link}
              to="/rapports-pdf2"
              eventKey="menu_rapports2"
            >
              <SidebarMenu.Nav.Icon>
                <PictureAsPdfOutlinedIcon />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title>Rapport bimensuel</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>

            <hr />
            <SidebarMenu.Nav.Link
              as={Link}
              to="/suivi-client"
              eventKey="menu_suivi"
            >
              <SidebarMenu.Nav.Icon>
                <PictoSuiviClient
                  className="sidebarIcon"
                  alt="Suivi client"
                  style={{ width: 24, height: 24 }}
                />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title>Suivi client</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
            {parseInt(localStorage.getItem("user_role")) <= 5 && (
              <SidebarMenu.Nav.Link
                as={Link}
                to="/plans-trade"
                eventKey="menu_plans"
              >
                <SidebarMenu.Nav.Icon>
                  <PictoPlanTrade
                    className="sidebarIcon"
                    alt="Plan Trade"
                    style={{ width: 24, height: 24 }}
                  />
                </SidebarMenu.Nav.Icon>
                <SidebarMenu.Nav.Title>Plans Trade</SidebarMenu.Nav.Title>
              </SidebarMenu.Nav.Link>
            )}
            <hr />
            <SidebarMenu.Nav.Link
              as={Link}
              to="/export-pdf"
              eventKey="export_pdf"
            >
              <SidebarMenu.Nav.Icon>
                <PictoPdf
                  className="sidebarIcon"
                  alt="PDF"
                  style={{ width: 24, height: 24 }}
                />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title>Export PDF</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
            {/*
            {parseInt(localStorage.getItem("user_role")) <= 3 && (
              <SidebarMenu.Nav.Link
                as={Link}
                to="/export-xls"
                eventKey="menu_export_xls"
              >
                <SidebarMenu.Nav.Icon>
                  <UploadFileOutlinedIcon />
                </SidebarMenu.Nav.Icon>
                <SidebarMenu.Nav.Title>Export datas .xls</SidebarMenu.Nav.Title>
              </SidebarMenu.Nav.Link>
            )}
            */}
            {parseInt(localStorage.getItem("user_role")) <= 2 && (
              <SidebarMenu.Nav.Link as={Link} to="/admin">
                <SidebarMenu.Nav.Icon>
                  <SettingsOutlinedIcon />
                </SidebarMenu.Nav.Icon>
                <SidebarMenu.Nav.Title>Administration </SidebarMenu.Nav.Title>
              </SidebarMenu.Nav.Link>
            )}
          </SidebarMenu.Nav>
        </SidebarMenu.Body>
      </SidebarMenu.Collapse>
    </SidebarMenu>
  );
};

export default Sidebar;
